// extracted by mini-css-extract-plugin
export default {"blender_bottle_item":"XH","blender_bottle_img":"YH","blender_bottle_info":"ZH","blender_bottle_title":"aI","blender_bottle_bold":"bI","blender_bottle_usual":"cI","blender_bottle_item_mob":"eI","addbutton":"fI","blender_bottle_title_mob":"gI","blender_bottle_bold_mob":"hI","blender_bottle_usual_mob":"iI","bolder":"jI","bottom_margin_4":"kI","bottom_margin_16":"lI"};
    if(module.hot) {
      // 1711394578681
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  